<template>
    <form class="form two gcrg20" @submit="checkForm">
        <div class="input-group col2-span" v-if="typeof validationErrors !== 'undefined'">
            <ul class="invalid-feedback">
                <p><strong>There were some errors in your submission:</strong></p>
                <li v-for="(value,key,index) in validationErrors">
                    {{ value[0] }}
                </li>
            </ul>
        </div>

        <div class="input-group grg10">
            <input
                    v-model="volunteer.first_name"
                    type="text"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.first_name ? ' is-invalid' : ''}`"
                    name="name"
                    id="first_name"
                    placeholder="Name*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.first_name"></lara-error>
        </div>
        <div class="input-group grg10">
            <input
                    v-model="volunteer.last_name"
                    type="text"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.last_name ? ' is-invalid' : ''}`"
                    name="name"
                    id="last_name"
                    placeholder="Surname*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.last_name"></lara-error>
        </div>
        <div class="input-group">
            <input type="date" placeholder="Date of Birth" v-model="volunteer.dob" class="form-control">
        </div>
        <div class="input-group">
            <input type="text" placeholder="Home Number" v-model="volunteer.home_number" class="form-control">
        </div>
        <div class="input-group grg10">
            <input
                    v-model="volunteer.email"
                    type="text"
                    class="form-control"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.email ? ' is-invalid' : ''}`"
                    placeholder="Email*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.email"></lara-error>
        </div>
        <div class="input-group grg10">
            <input
                    v-model="volunteer.cell_number"
                    type="text"
                    class="form-control"
                    :class="`form-control '  ${typeof validationErrors !== 'undefined' && validationErrors.cell_number ? ' is-invalid' : ''}`"
                    placeholder="Cell Number*"
            >
            <lara-error v-if="typeof validationErrors !== 'undefined'" :validation-error="validationErrors.cell_number"></lara-error>
        </div>
        <div class="input-group col2-span">
            <input v-model="volunteer.address" type="text" placeholder="Address" class="form-control">
        </div> 

        <div class="seperator col2-span"></div>

        <div class="input-group grg10 col2-span">
            <h4 class="bold pc1" style="margin-bottom: 10px">Hours available to volunteer</h4>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.hours_available"
                        type="checkbox"
                        value="mornings"
                        name="hours_available[]"
                        id="mornings"
                >
                <label class="custom-control-label" for="mornings">Mornings</label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.hours_available"
                        type="checkbox"
                        value="afternoons"
                        name="hours_available[]"
                        id="afternoons"
                >
                <label class="custom-control-label" for="afternoons">Afternoons</label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.hours_available"
                        type="checkbox"
                        value="evenings"
                        name="hours_available[]"
                        id="evenings"
                >
                <label class="custom-control-label" for="evenings">Evenings</label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.hours_available"
                        type="checkbox"
                        value="once_a_week"
                        name="hours_available[]"
                        id="once_a_week"
                >
                <label class="custom-control-label" for="once_a_week">Once a week</label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.hours_available"
                        type="checkbox"
                        value="twice_a_month"
                        name="hours_available[]"
                        id="twice_a_month"
                >
                <label class="custom-control-label" for="twice_a_month">Twice a month</label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.hours_available"
                        type="checkbox"
                        value="other"
                        name="hours_available[]"
                        id="other"
                >
                <label class="custom-control-label" for="other">Other</label>
            </div>
        </div>

        <div class="seperator col2-span"></div>

        <div class="input-group grg10 col2-span">
            <h4 class="bold pc1" style="margin-bottom: 10px">Hours available to volunteer</h4>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.services"
                        type="checkbox"
                        value="big_brother"
                        name="services[]"
                        id="big_brother"
                >
                <label class="custom-control-label" for="big_brother">
                    Big Brother / Sister Program
                </label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.services"
                        type="checkbox"
                        value="hospital_respite"
                        name="services[]"
                        id="hospital_respite"
                >
                <label class="custom-control-label" for="hospital_respite">
                    Hospital Respite
                </label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.services"
                        type="checkbox"
                        value="tutoring"
                        name="services[]"
                        id="tutoring"
                >
                <label class="custom-control-label" for="tutoring">
                    Tutoring
                </label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.services"
                        type="checkbox"
                        value="au_pairing"
                        name="services[]"
                        id="au_pairing"
                >
                <label class="custom-control-label" for="au_pairing">
                    Au Pairing
                </label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.services"
                        type="checkbox"
                        value="lifts"
                        name="services[]"
                        id="lifts"
                >
                <label class="custom-control-label" for="lifts">
                    Lifts
                </label>
            </div>
            <div class="form-check gcg10 custom-checkbox">
                <input
                        class="custom-control-input"
                        v-model="volunteer.services"
                        type="checkbox"
                        value="other_services"
                        name="services[]"
                        id="other_services"
                >
                <label class="custom-control-label" for="other_services">
                    Other
                </label>
            </div>
        </div>
        <div class="button">
            <button type="submit" class="primary rounded jstart">Submit</button>
        </div>
    </form>
</template>

<script>
    import TextInput from "./TextInput";
    import Checkbox from "./Checkbox";
    import {VueTelInput} from 'vue-tel-input';
    import TextArea from "./TextArea";
    import RadioComponent from "./RadioComponent";
    import CurrencyPicker from "./CurrencyPicker";
    import PaymentMethod from "./PaymentMethod";
    import AmountComponent from "./AmountComponent";
    import CurrencyConversionHover from "./CurrencyConversionHover";
    import LaraError from "../general/LaraError";

    export default {
        name: "VolunteerForm",
        components: {
            TextInput,
            Checkbox,
            VueTelInput,
            TextArea,
            RadioComponent,
            CurrencyPicker,
            PaymentMethod,
            AmountComponent,
            CurrencyConversionHover,
            LaraError,
        },
        data: () => ({
            volunteer: {
                name: '',
                last_name: '',
                dob: '',
                email: '',
                home_number: '',
                cell_number: '',
                address: '',
                hours_available: [],
                services: [],
            },
            submitted: false,
            validationErrors: undefined
        }),
        methods: {
            checkForm(e) {
                this.submitted = true;
                e.preventDefault();
                axios.post('/volunteer', this.volunteer).then(response => {
                    if (response.data.message === 'Form submitted successfully') {
                        this.volunteer = {};
                        this.showAlert();
                    }
                }).catch(errors => {
                    if (errors.response.status === 422) {
                        console.log(errors, errors.response.data, errors.response.data.errors);
                        this.validationErrors = errors.response.data.errors;
                        this.validationMessage = errors.response.data.message;
                        this.submitted = false;
                    }
                });
            },
            showAlert() {
                this.$swal.fire({
                    icon: 'success',
                    title: 'Thank you!',
                    html: 'Thank you for volunteering to support the DL Link. We will get back to you shortly!',
                });
            }
        }
    }
</script>

<style scoped>

</style>
